import { Typography, styled } from '@mui/material';

export const FormTitle = styled(Typography)({
  fontSize: '24px',
  textAlign: 'center',
  color: '#111827',
});
